import { isAnyTest, isIntegrationTest } from '@/lib/executionEnvironment';

export const collectionNameToTypeName = {
  ArbitalCaches: 'ArbitalCaches',
  ArbitalTagContentRels: 'ArbitalTagContentRel',
  AutomatedContentEvaluations: 'AutomatedContentEvaluation',
  Bans: 'Ban',
  Bookmarks: 'Bookmark',
  Books: 'Book',
  Chapters: 'Chapter',
  CkEditorUserSessions: 'CkEditorUserSession',
  ClientIds: 'ClientId',
  Collections: 'Collection',
  CommentEmbeddings: 'CommentEmbedding',
  CommentModeratorActions: 'CommentModeratorAction',
  Comments: 'Comment',
  Conversations: 'Conversation',
  CronHistories: 'CronHistory',
  CurationEmails: 'CurationEmail',
  CurationNotices: 'CurationNotice',
  DatabaseMetadata: 'DatabaseMetadata',
  DebouncerEvents: 'DebouncerEvents',
  DialogueChecks: 'DialogueCheck',
  DialogueMatchPreferences: 'DialogueMatchPreference',
  ElicitQuestionPredictions: 'ElicitQuestionPrediction',
  ElicitQuestions: 'ElicitQuestion',
  EmailTokens: 'EmailTokens',
  FieldChanges: 'FieldChange',
  GoogleServiceAccountSessions: 'GoogleServiceAccountSession',
  HomePageDesigns: 'HomePageDesign',
  IframeWidgetSrcdocs: 'IframeWidgetSrcdoc',
  Images: 'Images',
  JargonTerms: 'JargonTerm',
  LegacyData: 'LegacyData',
  LinkPreviewCaches: 'LinkPreviewCaches',
  LlmConversations: 'LlmConversation',
  LlmMessages: 'LlmMessage',
  Localgroups: 'Localgroup',
  LoginTokens: 'LoginToken',
  LWEvents: 'LWEvent',
  MailgunValidations: 'MailgunValidation',
  ManifoldProbabilitiesCaches: 'ManifoldProbabilitiesCache',
  Messages: 'Message',
  Migrations: 'Migration',
  ModerationTemplates: 'ModerationTemplate',
  ModeratorActions: 'ModeratorAction',
  MultiDocuments: 'MultiDocument',
  Notifications: 'Notification',
  OAuthAccessTokens: 'OAuthAccessToken',
  OAuthAuthorizationCodes: 'OAuthAuthorizationCode',
  OAuthClients: 'OAuthClient',
  PetrovDayActions: 'PetrovDayAction',
  PetrovDayLaunchs: 'PetrovDayLaunch',
  PodcastEpisodes: 'PodcastEpisode',
  Podcasts: 'Podcast',
  PostEmbeddings: 'PostEmbedding',
  PostRecommendations: 'PostRecommendation',
  PostRelations: 'PostRelation',
  PostViewTimes: 'PostViewTime',
  PostViews: 'PostViews',
  Posts: 'Post',
  ReadStatuses: 'ReadStatus',
  RecommendationsCaches: 'RecommendationsCache',
  Reports: 'Report',
  ResearchConversationEvents: 'ResearchConversationEvent',
  ResearchConversations: 'ResearchConversation',
  ResearchDocuments: 'ResearchDocument',
  ResearchEnvironments: 'ResearchEnvironment',
  ResearchProjects: 'ResearchProject',
  ResearchSandboxSessions: 'ResearchSandboxSession',
  ReviewVotes: 'ReviewVote',
  ReviewWinnerArts: 'ReviewWinnerArt',
  ReviewWinners: 'ReviewWinner',
  Revisions: 'Revision',
  RSSFeeds: 'RSSFeed',
  SandboxBaselineSnapshots: 'SandboxBaselineSnapshot',
  Sequences: 'Sequence',
  Sessions: 'Session',
  SideCommentCaches: 'SideCommentCache',
  SplashArtCoordinates: 'SplashArtCoordinate',
  Spotlights: 'Spotlight',
  Subscriptions: 'Subscription',
  TagFlags: 'TagFlag',
  TagRels: 'TagRel',
  Tags: 'Tag',
  Tweets: 'Tweet',
  TypingIndicators: 'TypingIndicator',
  TypoSuggestions: 'TypoSuggestion',
  UltraFeedEvents: 'UltraFeedEvent',
  UserMostValuablePosts: 'UserMostValuablePost',
  UserRateLimits: 'UserRateLimit',
  UserTagRels: 'UserTagRel',
  UserActivities: 'UserActivity',
  Users: 'User',
  Votes: 'Vote',
  YjsDocuments: 'YjsDocument',
  ...((isAnyTest && !isIntegrationTest) ? {
    TestCollection: 'TestCollection',
    TestCollection2: 'TestCollection2',
    TestCollection3: 'TestCollection3',
    TestCollection4: 'TestCollection4',
    TestCollection5: 'TestCollection5',
    TestCollection6: 'TestCollection6',
  } : {}),
} as const;

export const typeNameToCollectionName = {
  ArbitalCaches: 'ArbitalCaches',
  ArbitalTagContentRel: 'ArbitalTagContentRels',
  AutomatedContentEvaluation: 'AutomatedContentEvaluations',
  Ban: 'Bans',
  Bookmark: 'Bookmarks',
  Book: 'Books',
  Chapter: 'Chapters',
  CkEditorUserSession: 'CkEditorUserSessions',
  ClientId: 'ClientIds',
  Collection: 'Collections',
  CommentEmbedding: 'CommentEmbeddings',
  CommentModeratorAction: 'CommentModeratorActions',
  Comment: 'Comments',
  Conversation: 'Conversations',
  CronHistory: 'CronHistories',
  CurationEmail: 'CurationEmails',
  CurationNotice: 'CurationNotices',
  DatabaseMetadata: 'DatabaseMetadata',
  DebouncerEvents: 'DebouncerEvents',
  DialogueCheck: 'DialogueChecks',
  DialogueMatchPreference: 'DialogueMatchPreferences',
  ElicitQuestionPrediction: 'ElicitQuestionPredictions',
  ElicitQuestion: 'ElicitQuestions',
  EmailTokens: 'EmailTokens',
  FieldChange: 'FieldChanges',
  GoogleServiceAccountSession: 'GoogleServiceAccountSessions',
  HomePageDesign: 'HomePageDesigns',
  IframeWidgetSrcdoc: 'IframeWidgetSrcdocs',
  Images: 'Images',
  JargonTerm: 'JargonTerms',
  LegacyData: 'LegacyData',
  LinkPreviewCaches: 'LinkPreviewCaches',
  LlmConversation: 'LlmConversations',
  LlmMessage: 'LlmMessages',
  Localgroup: 'Localgroups',
  LoginToken: 'LoginTokens',
  LWEvent: 'LWEvents',
  MailgunValidation: 'MailgunValidations',
  ManifoldProbabilitiesCache: 'ManifoldProbabilitiesCaches',
  Message: 'Messages',
  Migration: 'Migrations',
  ModerationTemplate: 'ModerationTemplates',
  ModeratorAction: 'ModeratorActions',
  MultiDocument: 'MultiDocuments',
  Notification: 'Notifications',
  OAuthAccessToken: 'OAuthAccessTokens',
  OAuthAuthorizationCode: 'OAuthAuthorizationCodes',
  OAuthClient: 'OAuthClients',
  PetrovDayAction: 'PetrovDayActions',
  PetrovDayLaunch: 'PetrovDayLaunchs',
  PodcastEpisode: 'PodcastEpisodes',
  Podcast: 'Podcasts',
  PostEmbedding: 'PostEmbeddings',
  PostRecommendation: 'PostRecommendations',
  PostRelation: 'PostRelations',
  PostViewTime: 'PostViewTimes',
  PostViews: 'PostViews',
  Post: 'Posts',
  ReadStatus: 'ReadStatuses',
  RecommendationsCache: 'RecommendationsCaches',
  Report: 'Reports',
  ResearchConversationEvent: 'ResearchConversationEvents',
  ResearchConversation: 'ResearchConversations',
  ResearchDocument: 'ResearchDocuments',
  ResearchEnvironment: 'ResearchEnvironments',
  ResearchProject: 'ResearchProjects',
  ResearchSandboxSession: 'ResearchSandboxSessions',
  ReviewVote: 'ReviewVotes',
  ReviewWinnerArt: 'ReviewWinnerArts',
  ReviewWinner: 'ReviewWinners',
  Revision: 'Revisions',
  RSSFeed: 'RSSFeeds',
  SandboxBaselineSnapshot: 'SandboxBaselineSnapshots',
  Sequence: 'Sequences',
  Session: 'Sessions',
  SideCommentCache: 'SideCommentCaches',
  SplashArtCoordinate: 'SplashArtCoordinates',
  Spotlight: 'Spotlights',
  Subscription: 'Subscriptions',
  TagFlag: 'TagFlags',
  TagRel: 'TagRels',
  Tag: 'Tags',
  Tweet: 'Tweets',
  TypingIndicator: 'TypingIndicators',
  TypoSuggestion: 'TypoSuggestions',
  UltraFeedEvent: 'UltraFeedEvents',
  UserMostValuablePost: 'UserMostValuablePosts',
  UserRateLimit: 'UserRateLimits',
  UserTagRel: 'UserTagRels',
  UserActivity: 'UserActivities',
  User: 'Users',
  Vote: 'Votes',
  YjsDocument: 'YjsDocuments',
  ...((isAnyTest && !isIntegrationTest) ? {
    TestCollection: 'TestCollection',
    TestCollection2: 'TestCollection2',
    TestCollection3: 'TestCollection3',
    TestCollection4: 'TestCollection4',
    TestCollection5: 'TestCollection5',
    TestCollection6: 'TestCollection6',
  } : {}),
} as const;

export const tableNameToCollectionName = {
  arbitalcaches: 'ArbitalCaches',
  arbitaltagcontentrels: 'ArbitalTagContentRels',
  automatedcontentevaluations: 'AutomatedContentEvaluations',
  bans: 'Bans',
  bookmarks: 'Bookmarks',
  books: 'Books',
  chapters: 'Chapters',
  ckeditorusersessions: 'CkEditorUserSessions',
  clientids: 'ClientIds',
  collections: 'Collections',
  commentembeddings: 'CommentEmbeddings',
  commentmoderatoractions: 'CommentModeratorActions',
  comments: 'Comments',
  conversations: 'Conversations',
  cronhistories: 'CronHistories',
  curationemails: 'CurationEmails',
  curationnotices: 'CurationNotices',
  databasemetadata: 'DatabaseMetadata',
  debouncerevents: 'DebouncerEvents',
  dialoguechecks: 'DialogueChecks',
  dialoguematchpreferences: 'DialogueMatchPreferences',
  elicitquestionpredictions: 'ElicitQuestionPredictions',
  elicitquestions: 'ElicitQuestions',
  emailtokens: 'EmailTokens',
  fieldchanges: 'FieldChanges',
  googleserviceaccountsessions: 'GoogleServiceAccountSessions',
  homepagedesigns: 'HomePageDesigns',
  iframewidgetsrcdocs: 'IframeWidgetSrcdocs',
  images: 'Images',
  jargonterms: 'JargonTerms',
  legacydata: 'LegacyData',
  linkpreviewcaches: 'LinkPreviewCaches',
  llmconversations: 'LlmConversations',
  llmmessages: 'LlmMessages',
  localgroups: 'Localgroups',
  logintokens: 'LoginTokens',
  lwevents: 'LWEvents',
  mailgunvalidations: 'MailgunValidations',
  manifoldprobabilitiescaches: 'ManifoldProbabilitiesCaches',
  messages: 'Messages',
  migrations: 'Migrations',
  moderationtemplates: 'ModerationTemplates',
  moderatoractions: 'ModeratorActions',
  multidocuments: 'MultiDocuments',
  notifications: 'Notifications',
  oauthaccesstokens: 'OAuthAccessTokens',
  oauthauthorizationcodes: 'OAuthAuthorizationCodes',
  oauthclients: 'OAuthClients',
  petrovdayactions: 'PetrovDayActions',
  petrovdaylaunchs: 'PetrovDayLaunchs',
  podcastepisodes: 'PodcastEpisodes',
  podcasts: 'Podcasts',
  postembeddings: 'PostEmbeddings',
  postrecommendations: 'PostRecommendations',
  postrelations: 'PostRelations',
  postviewtimes: 'PostViewTimes',
  postviews: 'PostViews',
  posts: 'Posts',
  readstatuses: 'ReadStatuses',
  recommendationscaches: 'RecommendationsCaches',
  reports: 'Reports',
  researchconversationevents: 'ResearchConversationEvents',
  researchconversations: 'ResearchConversations',
  researchdocuments: 'ResearchDocuments',
  researchenvironments: 'ResearchEnvironments',
  researchprojects: 'ResearchProjects',
  researchsandboxsessions: 'ResearchSandboxSessions',
  reviewvotes: 'ReviewVotes',
  reviewwinnerarts: 'ReviewWinnerArts',
  reviewwinners: 'ReviewWinners',
  revisions: 'Revisions',
  rssfeeds: 'RSSFeeds',
  sandboxbaselinesnapshots: 'SandboxBaselineSnapshots',
  sequences: 'Sequences',
  sessions: 'Sessions',
  sidecommentcaches: 'SideCommentCaches',
  splashartcoordinates: 'SplashArtCoordinates',
  spotlights: 'Spotlights',
  subscriptions: 'Subscriptions',
  tagflags: 'TagFlags',
  tagrels: 'TagRels',
  tags: 'Tags',
  tweets: 'Tweets',
  typingindicators: 'TypingIndicators',
  typosuggestions: 'TypoSuggestions',
  ultrafeedevents: 'UltraFeedEvents',
  usermostvaluableposts: 'UserMostValuablePosts',
  userratelimits: 'UserRateLimits',
  usertagrels: 'UserTagRels',
  useractivities: 'UserActivities',
  users: 'Users',
  votes: 'Votes',
  yjsdocuments: 'YjsDocuments',
  ...((isAnyTest && !isIntegrationTest) ? {
    testcollection: 'TestCollection',
    testcollection2: 'TestCollection2',
    testcollection3: 'TestCollection3',
    testcollection4: 'TestCollection4',
    testcollection5: 'TestCollection5',
    testcollection6: 'TestCollection6',
  } : {}),
} as const;
